import apiClient from "./apiClient";

export const crossTally = async (clientClaimId, driverPayoutId) => {
  const response = await apiClient.post("/reconciliation/cross-tally", {
    clientClaimId,
    driverPayoutId,
  });
  return response.data;
};

export const validateTrips = async () => {
  const response = await apiClient.get("/trip-validation/validate-trip");
  return response.data;
};

const reconciliationApi = {
  crossTally,
  validateTrips,
};

export default reconciliationApi;
